import { render, staticRenderFns } from "./OrderAudit.vue?vue&type=template&id=1fd031f8&scoped=true"
import script from "./OrderAudit.vue?vue&type=script&lang=ts"
export * from "./OrderAudit.vue?vue&type=script&lang=ts"
import style0 from "./OrderAudit.vue?vue&type=style&index=0&id=1fd031f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd031f8",
  null
  
)

export default component.exports